var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{staticStyle:{"color":"#2196f3"},attrs:{"icon":"block","size":"small","type":"link"},on:{"click":e => _vm.$emit('click', e)}},[_vm._v(" 克隆 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }